import * as yup from 'yup';

export const subscribe_schema = {
  unit: '',
  fund_amount: '',
  read_suitability_report: false,
  // transaction_type: null,
  // agree_terms: false,
};

export const subscribe_validation_schema = yup.object().shape({
  unit: yup
    .string()
    .required('amount_required')
    .matches(/^(?:\d+|\d+\.\d*)$/, 'amount_digit_validation'),
  read_suitability_report: yup.boolean(),
  // transaction_type: yup.object().required('transaction_type_required'),
  // agree_terms: yup.boolean().required('agree_terms').isTrue('agree_terms'),
});
